/**
 * @file DeviceTabs.tsx
 * @description Вкладки [ПК | Телефон] у полей, где у телефона своё значение
 * (phase19.16, партия SB120, этап 1; uiux-sb120-stage1 §2.1 высота, §2.3
 * точка фокуса, §2.4 кадр, §3 кадр фото): 48 px на касании. Точка у
 * «Телефона» — у телефона своё значение (иначе — «как на ПК»).
 */

import { Segmented } from "../../../site-view/Segmented";
import type { Device } from "../../../../lib/site-builder/look-size";

interface Props {
  value: Device;
  onChange: (device: Device) => void;
  /** Подпись для чтеца экрана: «Высота: экран». */
  label: string;
  /** У телефона своё значение. */
  phoneOwn?: boolean;
}

export function DeviceTabs({ value, onChange, label, phoneOwn = false }: Props) {
  return (
    <Segmented
      aria-label={label}
      options={[
        { value: "desktop" as const, label: "ПК" },
        { value: "phone" as const, label: phoneOwn ? "Телефон •" : "Телефон", ariaLabel: phoneOwn ? "Телефон, своё значение" : "Телефон" },
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
